function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 291",
  d: "M102.936 53.009l-8.682.586a43.609 43.609 0 00-40.6 40.6l-.585 8.7a.916.916 0 01-1.831 0l-.587-8.7a43.608 43.608 0 00-40.6-40.6l-8.681-.586a.861.861 0 010-1.722l8.681-.586a43.608 43.608 0 0040.6-40.6l.587-8.681a.916.916 0 111.831 0l.585 8.681a43.609 43.609 0 0040.624 40.6l8.681.586a.861.861 0 11-.018 1.722z",
  fill: "none",
  stroke: "#3c00dc"
});

function SvgShineinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104.306,
    height: 104.315,
    viewBox: "0 0 104.306 104.315"
  }, props), _ref);
}

export default SvgShineinline;